// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 10,
  type: "announcement_bar",
  name: "Announcement Bar",
  category: "Header",
  description: "A message bar you can add more than once and place anywhere on the home page",
  defaultSettings: {
    text: "⚡ Free Express Delivery Nationwide On Orders Over Rs. 2,500",
    link: "/collection",
    backgroundColor: "#111827",
    textColor: "#ffffff",
  },
  fields: [
    { key: "text", label: "Announcement Text", type: "text" },
    { key: "link", label: "Link URL", type: "text" },
    { key: "backgroundColor", label: "Background Color", type: "color" },
    { key: "textColor", label: "Text Color", type: "color" },
  ],
};

export default definition;
